var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-container" }, [
      _c("div", { staticClass: "info-item" }, [
        _c("div", { staticClass: "img-container" }, [
          _c("img", {
            staticClass: "carry-on-img",
            attrs: {
              src:
                "https://flyfrontier-com-frontdoor-en-chh3dufqdpdff8h9.a02.azurefd.net/images/carry-on-icon.png",
              alt: ""
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-details" }, [
          _c("div", { staticClass: "head" }, [_vm._v("Carry On Bag")]),
          _vm._v(" "),
          _c("div", [_vm._v('10"D X 16"W  X 24"H')]),
          _vm._v(" "),
          _c("div", [_vm._v("< 35 lbs")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "info-item" }, [
        _c("div", { staticClass: "img-container" }, [
          _c("img", {
            staticClass: "checked-img",
            attrs: {
              src:
                "https://flyfrontier-com-frontdoor-en-chh3dufqdpdff8h9.a02.azurefd.net/images/checked-icon.png",
              alt: ""
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-details" }, [
          _c("div", { staticClass: "head" }, [_vm._v("Checked Bag")]),
          _vm._v(" "),
          _c("div", [_vm._v("62 Linear Inches")]),
          _vm._v(" "),
          _c("div", [_vm._v("< 40 LBS")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "info-item" }, [
        _c("div", { staticClass: "img-container" }, [
          _c("img", {
            staticClass: "personal-item-img",
            attrs: {
              src:
                "https://flyfrontier-com-frontdoor-en-chh3dufqdpdff8h9.a02.azurefd.net/images/personal-item-icon.png",
              alt: ""
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-details" }, [
          _c("div", { staticClass: "head" }, [_vm._v("Personal Item")]),
          _vm._v(" "),
          _c("div", [_vm._v('8"D X 18"W X 14"H')]),
          _vm._v(" "),
          _c("div", [
            _vm._v("Personal item size will be checked during boarding")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-310395cd", { render: render, staticRenderFns: staticRenderFns })
  }
}